import React from 'react';
import { isBelowMin, isReturnOnly } from '../utils';
import { RETURN_ONLY_TITLE } from '../constants';

const OnHandCell = ({ row }) => {
    const { on_hand_count } = row.original;
    if (isReturnOnly(row.original)) {
        return (
            <span className="text-xs text-muted" title={RETURN_ONLY_TITLE}>
                Returns only
            </span>
        );
    }
    return (
        <span className={`text-sm ${isBelowMin(row.original) ? 'font-semibold text-destructive' : ''}`}>
            {on_hand_count ?? 0}
        </span>
    );
};

export default OnHandCell;
